import { useCallback } from 'react';

import { Close, Maximize, Minimize } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import AgenticAiAgentsButton from '../AgenticAiAgents/AgenticAiAgentsButton.jsx';

type Props = {
  onClose: () => void;
  isFullScreen: boolean;
  setIsFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
  chatId: string;
};

type HeaderProps = {
  chatId?: string;
  children: React.ReactNode;
};

const AgenticAiHeader = ({
  onClose,
  isFullScreen,
  setIsFullScreen,
  chatId,
}: Props) => {
  const expandFullScreen = useCallback(() => {
    setIsFullScreen((prev) => !prev);
  }, [setIsFullScreen]);

  const Header = isFullScreen ? HeaderFullScreen : HeaderCompact;

  return (
    <Header chatId={chatId}>
      {chatId && !isFullScreen && <AgenticAiAgentsButton />}
      <div className="flex flex-row">
        <Button
          icon
          size={'large'}
          variant={'text'}
          onClick={expandFullScreen}
          aria-label="agentic-chat-expand"
        >
          {isFullScreen ? <Minimize /> : <Maximize />}
        </Button>

        <Button
          icon
          size={'large'}
          variant={'text'}
          onClick={onClose}
          aria-label="agentic-chat-close"
        >
          <Close />
        </Button>
      </div>
    </Header>
  );
};

export default AgenticAiHeader;

const HeaderCompact = ({ children, chatId }: HeaderProps) => {
  return (
    <div
      className={cn(
        'flex w-full flex-row items-center',
        chatId ? 'justify-between' : 'justify-end px-4',
      )}
    >
      {children}
    </div>
  );
};

const HeaderFullScreen = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex w-full flex-row items-center justify-end border-b border-ui-tertiary px-8">
      <div className="flex flex-row">{children}</div>
    </div>
  );
};
